import React, { useRef, useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
// import Header from "../Header/Header";
import Footer from "../Footer/Footer";

gsap.registerPlugin(ScrollTrigger);

const Home = () => {
  useEffect(() => {
    const handleResize = () => {
      window.location.reload(); // refresh page
      window.scrollTo(0, 0); // ensure scroll is at top
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const horizontalSection = useRef(null); // the whole section that will be pinned
  const track = useRef(null); // the wide track that will be translated left
  const stInstance = useRef(null);
  const ro = useRef(null);

  useEffect(() => {
    const el = horizontalSection.current;
    const slider = track.current;
    if (!el || !slider) return;

    // kill previous instance safely
    const killExisting = () => {
      if (stInstance.current) {
        stInstance.current.kill();
        stInstance.current = null;
      }
      // remove any ScrollTriggers attached to this trigger
      ScrollTrigger.getAll().forEach((t) => {
        if (t.trigger === el) t.kill();
      });
      gsap.set(slider, { clearProps: "transform" });
    };

    const setup = () => {
      killExisting();
      // measure
      const sliderWidth = slider.scrollWidth;
      const viewportWidth = window.innerWidth;
      const distance = Math.max(sliderWidth - viewportWidth, 0);

      // nothing to do if content fits viewport
      if (distance <= 0) {
        ScrollTrigger.refresh();
        return;
      }

      stInstance.current = gsap.to(slider, {
        x: -distance,
        ease: "none",
        // translate the whole track
        scrollTrigger: {
          trigger: el,
          start: "top top",
          end: `+=${distance}`, // make the scroll length equal to the translation distance
          scrub: 0.8,
          pin: true,
          anticipatePin: 1,
          invalidateOnRefresh: true,
        },
      });

      // ensure proper refresh after setup
      ScrollTrigger.refresh();
    };

    // initial delayed setup to let fonts/images settle
    const t = setTimeout(setup, 60);

    // ResizeObserver to recompute when layout changes
    if ("ResizeObserver" in window) {
      ro.current = new ResizeObserver(() => {
        clearTimeout(t);
        // slight debounce
        setTimeout(setup, 50);
      });
      ro.current.observe(slider);
      ro.current.observe(document.body);
    } else {
      window.addEventListener("resize", setup);
    }

    // also run setup on page load (images)
    window.addEventListener("load", setup);

    return () => {
      clearTimeout(t);
      window.removeEventListener("load", setup);
      if (ro.current) ro.current.disconnect();
      else window.removeEventListener("resize", setup);
      killExisting();
      ScrollTrigger.refresh();
    };
  }, []);

  return (
    <>
      {/* <Header /> */}
      <div className="relative min-h-screen overflow-x-hidden">
        <div className="fixed top-0 left-0 w-full h-screen bg-cover bg-center bg-no-repeat">
          <img
            src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/fe12801d-ae41-4ad6-ec2d-26935c679a00/public" // Tao_homepage_banner.webp
            alt="Img"
            className="h-full w-full object-cover object-top"
          />

          <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
            <img
              src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/6ffe5b9d-8d3d-41a2-4d81-5ddfac104500/public" // tao_logoFullWhite.webp
              alt="Img"
              className="h-24 md:h-36 w-auto"
            />
          </div>

          <div className="absolute bottom-10 left-1/2 -translate-x-1/2 w-full px-4">
            <p className="text-white text-sm text-center uppercase font-bold">
              where stillness becomes a destination
            </p>
          </div>
        </div>

        <div className="relative z-10 mt-[100vh] bg-[#ffffff]">
          <div className="w-full text-[#948A78] text-sm lg:text-base 2xl:text-lg leading-relaxed">
            {/* MOBILE - First vertical section */}
            <section className="lg:hidden h-[430vh] md:h-[350vh]">
              {/* Banner */}
              {/* <div className="h-[100vh] w-full relative max-w-[100vw] overflow-hidden">
                <img
                  src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/fe12801d-ae41-4ad6-ec2d-26935c679a00/public" // Tao_homepage_banner.webp
                  alt="Img"
                  className="h-full w-full object-cover object-top"
                />

                <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
                  <img
                    src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/6ffe5b9d-8d3d-41a2-4d81-5ddfac104500/public" // tao_logoFullWhite.webp
                    alt="Img"
                    className="h-24 md:h-36 w-auto"
                  />
                </div>

                <div className="absolute bottom-10 left-1/2 -translate-x-1/2 w-full px-4">
                  <p className="text-white text-sm text-center uppercase font-bold">
                    where stillness becomes a destination
                  </p>
                </div>
              </div> */}

              {/* Section 1 - Image */}
              <div className="h-[100vh] w-full relative bg-pink-200/0 max-w-[100vw] overflow-hidden">
                <div className="absolute top-0 left-0 right-10 sm:right-40 md:right-60">
                  <img
                    src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/fcfaf156-fd7c-485a-1734-e3a3ace3c900/public" // Tao_img1.webp
                    alt="Img"
                    className="h-[45vh] sm:h-[50vh] md:h-[65vh] w-full object-cover object-bottom"
                  />
                </div>
                <div className="absolute bottom-0 left-0 right-5">
                  <div className="flex flex-col gap-10 items-end lg:justify-between">
                    <div className="text-sm text-right space-y-5 w-[200px]">
                      <p>
                        A space to pause, <br /> to feel the wind move <br />{" "}
                        through arches, <br /> to watch the light fall <br />{" "}
                        without urgency.
                      </p>

                      <p>
                        Rooted in Taoist principles <br /> of balance and
                        presence, <br />
                        our home is crafted to <br /> help you return to yours -{" "}
                        <br /> the one within.
                      </p>

                      <p>
                        Come as you are. <br /> Leave a little lighter.
                      </p>
                    </div>
                  </div>
                </div>

                {/* <div className="absolute top-0 left-0 right-20 sm:right-[25%] md:right-[300px]">
            <img
              src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/fcfaf156-fd7c-485a-1734-e3a3ace3c900/public" // Tao_img1.webp
              alt="Img"
              className="h-[50vw] md:h-[45vw] w-full object-cover object-center"
            />
          </div> */}

                {/* <div className="absolute bottom-10 right-5 w-[150px]">
            <div className="text-sm text-right space-y-5 bg-[#]">
              <p>
                A space to pause, to feel the wind move through arches, to watch
                the light fall without urgency.
              </p>

              <p>
                Rooted in Taoist principles of balance and presence, our home is
                crafted to help you return to yours - the one within.
              </p>

              <p>Come as you are. Leave a little lighter.</p>
            </div>
          </div> */}
              </div>

              {/* Section 2 - Grids */}
              <div className="h-[190vh] md:h-[110vh] w-full relative bg-yellow-200/0 max-w-[100vw] overflow-hidden pt-10">
                <div className="absolute right-5 flex items-center justify-end w-full bg-sky-300/0">
                  <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-[1%]">
                    <div className="ml-14">
                      <img
                        src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/1a111f92-cd9a-45c7-37f8-8e76740bf700/public" // Tao_home_img2.webp
                        alt="Img"
                        className="h-[60vh] md:h-[95vh] w-full object-cover object-center"
                      />
                    </div>

                    <div className="grid grid-cols-[120px_auto] md:items-end gap-2 mt-0 md:mt-16">
                      <div className="text-right mb-96 md:mb-[540px]">
                        <p className="font-bold text-lg">
                          Our <br /> Philosophy
                        </p>
                      </div>

                      <div className="text-sm space-y-5 mt-14 lg:mt-10 w-44 md:w-64">
                        <p>
                          House of Tao is designed to help you disconnect from
                          noise and reconnect with what matters: nature, rest,
                          and self.
                        </p>

                        <p>
                          We follow Taoist principles: living in alignment with
                          the natural world, choosing presence over pace and
                          embracing the simple beauty of each moment.
                        </p>

                        <p>
                          From the outside, it’s quiet and grounded. But step in
                          and you’ll feel something shift, not because of grand
                          gestures or luxury for luxury’s sake, but because
                          every corner has been thought through.
                        </p>

                        <p>
                          Here, beauty is not about perfection. It’s about
                          presence. In the way light moves through a room. In
                          how time begins to stretch. In how you begin to return
                          to yourself.
                        </p>

                        <br className="md:hidden" />
                        <br className="md:hidden" />

                        <p>Welcome home. To yourself.</p>

                        <div className="">
                          <a
                            href="/"
                            className="uppercase underline underline-offset-8 hover:underline-offset-4 transition-all ease-in-out duration-300"
                          >
                            learn more
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Section 3 - Image and Text */}
              <div className="h-[140vh] w-full bg-sky-300/0 max-w-[100vw] overflow-hidden">
                <img
                  src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/1df8e277-f100-42d4-9e7a-2783edc10f00/public" // Tao_home_img3.webp
                  alt="Img"
                  className="h-[50vh] w-full object-cover object-center"
                />

                <div className="absolute right-5 flex justify-end w-full">
                  <p className="text-right mt-5 max-w-[320px]">
                    A 5-bedroom home with ensuite baths, vaulted living,
                    sun-washed courtyards, a private pool, and an open-sky
                    jacuzzi — designed for connection and calm.
                  </p>
                </div>

                <div className="absolute flex items-center justify-center sm:justify-start w-full">
                  <div className="grid grid-cols-[125px_auto] gap-2 mt-52 mb-5 sm:ml-5">
                    <div className="text-right">
                      <p className="font-bold text-lg">
                        The Space at <br /> a Glance
                      </p>
                    </div>

                    <div className="text-sm space-y-5 mt-14 lg:mt-10 w-44 md:w-56 lg:w-72">
                      <p>
                        A 5-bedroom home with ensuite baths, vaulted living,
                        sun-washed courtyards, a private pool, and an open-sky
                        jacuzzi — designed for connection and calm.
                      </p>

                      <br />
                      <br />

                      <div className="">
                        <a
                          href="/OurSpaces"
                          className="uppercase underline underline-offset-8 hover:underline-offset-4 transition-all ease-in-out duration-300"
                        >
                          our spaces
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* DESKTOP- First vertical section */}
            <section className="hidden lg:block h-[360vh] md:h-[300vh]">
              {/* Banner */}
              {/* <div className="h-[100vh] w-full relative max-w-[100vw] overflow-hidden">
                <img
                  src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/fe12801d-ae41-4ad6-ec2d-26935c679a00/public" // Tao_homepage_banner.webp
                  alt="Img"
                  className="h-full w-full object-cover object-top"
                />

                <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
                  <img
                    src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/6ffe5b9d-8d3d-41a2-4d81-5ddfac104500/public" // tao_logoFullWhite.webp
                    alt="Img"
                    className="h-24 md:h-36 w-auto"
                  />
                </div>

                <div className="absolute bottom-10 left-1/2 -translate-x-1/2 w-full px-4">
                  <p className="text-white text-sm text-center uppercase font-bold">
                    where stillness becomes a destination
                  </p>
                </div>
              </div> */}

              {/* Section 1 - Image */}
              <div className="h-[100vh] w-full relative bg-pink-200/0 max-w-[100vw] overflow-hidden">
                <div className="absolute top-0 left-0 right-5">
                  <div className="flex flex-col lg:flex-row gap-10 lg:gap-[5%] items-end lg:justify-between">
                    <img
                      src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/fcfaf156-fd7c-485a-1734-e3a3ace3c900/public" // Tao_img1.webp
                      alt="Img"
                      className="h-[50vh] lg:h-[94vh] w-[80%] object-cover object-bottom"
                    />

                    <div className="text-sm 2xl:text-lg text-right space-y-5 w-[250px] lg:w-[180px] 2xl:w-[200px] bg-green-300/0">
                      <p>
                        A space to pause, <br /> to feel the wind move <br />{" "}
                        through arches, <br /> to watch the light <br /> fall
                        without urgency.
                      </p>

                      <p>
                        Rooted in Taoist principles <br /> <br /> of balance and
                        presence, <br />
                        our home is crafted to <br /> help you return to yours -{" "}
                        <br /> the one within.
                      </p>

                      <p>
                        Come as you are. <br /> Leave a little lighter.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Section 2 - Grids */}
              <div className="h-[160vh] md:h-[100vh] w-full relative bg-yellow-200/0 max-w-[100vw] overflow-hidden">
                <div className="absolute right-0 lg:left-1/2 lg:-translate-x-1/2 flex items-center justify-center w-full bg-green-300/0">
                  <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-[1%]">
                    <div className="ml-14 lg:ml-0">
                      <img
                        src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/1a111f92-cd9a-45c7-37f8-8e76740bf700/public" // Tao_home_img2.webp
                        alt="Img"
                        className="h-[60vh] md:h-[95vh] w-full object-cover object-center"
                      />
                    </div>

                    <div className="grid grid-cols-[120px_auto] gap-2 mt-0 lg:mt-24 pr-4 xl:items-end bg-purple-400/0">
                      <div className="text-right lg:mb-[480px] 2xl:mb-[760px]">
                        <p className="font-bold text-lg 2xl:text-2xl">
                          Our <br /> Philosophy
                        </p>
                      </div>

                      <div className="text-sm 2xl:text-lg space-y-5 mt-14 w-44 md:w-56 lg:w-72">
                        <p>
                          House of Tao is designed to help you disconnect from
                          noise and reconnect with what matters: nature, rest,
                          and self.
                        </p>

                        <p>
                          We follow Taoist principles: living in alignment with
                          the natural world, choosing presence over pace and
                          embracing the simple beauty of each moment.
                        </p>

                        <p>
                          From the outside, it’s quiet and grounded. But step in
                          and you’ll feel something shift, not because of grand
                          gestures or luxury for luxury’s sake, but because
                          every corner has been thought through.
                        </p>

                        <p>
                          Here, beauty is not about perfection. It’s about
                          presence. In the way light moves through a room. In
                          how time begins to stretch. In how you begin to return
                          to yourself.
                        </p>

                        <br />
                        <br />

                        <p>Welcome home. To yourself.</p>

                        <div className="xl:hidden">
                          <a
                            href="/"
                            className="uppercase underline underline-offset-8 hover:underline-offset-4 transition-all ease-in-out duration-300"
                          >
                            learn more
                          </a>
                        </div>
                      </div>
                    </div>

                    <div className="hidden xl:block">
                      <img
                        src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/fcfaf156-fd7c-485a-1734-e3a3ace3c900/public" // Tao_img1.webp
                        alt="Img"
                        className="h-[40vh] object-cover object-center"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="h-[100vh] w-full bg-sky-300/0">
                <div className="absolute left-1/2 -translate-x-1/2 w-full bg-yellow-300/0">
                  <div className="grid grid-cols-[auto_400px] items-end justify-between gap-10 mx-10">
                    <img
                      src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/1b5553c7-0d3e-4ec8-4240-3a650b494800/public" // tao_img3.webp
                      alt="Img"
                      className="h-[95vh] w-full object-cover object-center"
                    />

                    <p className="text-sm 2xl:text-lg bg-pink-400/0">
                      A 5-bedroom home with ensuite baths, vaulted living,
                      sun-washed courtyards, a private pool, and an open-sky
                      jacuzzi — designed for connection and calm.
                    </p>
                  </div>
                </div>
              </div>
            </section>

            {/* Horizontal scroll section */}
            <section
              ref={horizontalSection}
              className="relative h-screen overflow-hidden bg-gray-900/0"
            >
              {/* track: translate this element horizontally */}
              <div
                ref={track}
                className="flex h-full will-change-transform"
                style={{ width: "max-content" }} // ensures scrollWidth reflects panels
              >
                {/* MOBILE - Horizontal section */}
                <div className="lg:hidden min-w-[300px] w-[96vw] flex-shrink-0 py-2 bg-red-500/0">
                  <div className="grid grid-cols-1 md:grid-cols-2 h-full">
                    <img
                      src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/fe12801d-ae41-4ad6-ec2d-26935c679a00/public" // Tao_homepage_banner.webp
                      alt="Img"
                      className="h-[35vh] md:h-[50vh] w-[90%] md:w-full object-cover object-center md:self-top"
                    />

                    <div className="ml-5 md:self-end">
                      <div className="flex justify-end gap-5 my-6">
                        <p className="uppercase">the living room</p>
                        <div class="flex items-center">
                          <div class="h-[1px] w-28 bg-[#948A78]"></div>

                          <div class="relative w-3 h-3 -ml-1">
                            <div class="absolute w-2 h-[1px] bg-[#948A78] transform rotate-45 origin-left top-0 left-0"></div>
                            <div class="absolute w-2 h-[1px] bg-[#948A78] transform -rotate-45 origin-left bottom-0 left-0"></div>
                          </div>
                        </div>
                      </div>

                      <div className="flex flex-col ml-auto max-w-[260px] space-y-4">
                        <p>
                          This space is designed for pause. <br /> For
                          conversation.
                          <br />
                          For silence. <br /> For everything in between.
                        </p>

                        <p>
                          One seating is a deep, sectional sofa, perfect for
                          long hours and even longer conversations. Another
                          faces the TV, for easy, familiar comfort. In one
                          corner, a round window offers a cozy reading spot.
                        </p>

                        <p className="hidden sm:block">
                          There’s also a small bar tucked into the space, ideal
                          for an evening drink.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="lg:hidden min-w-[300px] w-[96vw] flex-shrink-0 py-2 pl-4 bg-green-500/0">
                  <div className="grid grid-cols-1 md:grid-cols-2 h-full">
                    <img
                      src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/fe12801d-ae41-4ad6-ec2d-26935c679a00/public" // Tao_homepage_banner.webp
                      alt="Img"
                      className="h-[35vh] md:h-[50vh] w-[90%] md:w-full object-cover object-center md:self-top"
                    />

                    <div className="ml-5 md:self-end">
                      <div className="flex justify-end gap-5 my-6">
                        <p className="uppercase">the&nbsp;dining&nbsp;room</p>
                        <div class="flex items-center">
                          <div class="h-[1px] w-28 bg-[#948A78]"></div>

                          <div class="relative w-3 h-3 -ml-1">
                            <div class="absolute w-2 h-[1px] bg-[#948A78] transform rotate-45 origin-left top-0 left-0"></div>
                            <div class="absolute w-2 h-[1px] bg-[#948A78] transform -rotate-45 origin-left bottom-0 left-0"></div>
                          </div>
                        </div>
                      </div>

                      <div className="flex flex-col ml-auto max-w-[260px] space-y-4">
                        <p>
                          This space is designed for pause. <br /> For
                          conversation.
                          <br />
                          For silence. <br /> For everything in between.
                        </p>

                        <p>
                          One seating is a deep, sectional sofa, perfect for
                          long hours and even longer conversations. Another
                          faces the TV, for easy, familiar comfort. In one
                          corner, a round window offers a cozy reading spot.
                        </p>

                        <p className="hidden sm:block">
                          There’s also a small bar tucked into the space, ideal
                          for an evening drink.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="lg:hidden min-w-[300px] w-[96vw] flex-shrink-0 py-2 pl-4 bg-blue-500/0">
                  <div className="grid grid-cols-1 md:grid-cols-2 h-full">
                    <img
                      src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/fe12801d-ae41-4ad6-ec2d-26935c679a00/public" // Tao_homepage_banner.webp
                      alt="Img"
                      className="h-[35vh] md:h-[50vh] w-[90%] md:w-full object-cover object-center md:self-top"
                    />

                    <div className="ml-5 md:self-end">
                      <div className="flex justify-end gap-5 my-6">
                        <p className="uppercase">bedroom 01</p>
                        <div class="flex items-center">
                          <div class="h-[1px] w-28 bg-[#948A78]"></div>

                          <div class="relative w-3 h-3 -ml-1">
                            <div class="absolute w-2 h-[1px] bg-[#948A78] transform rotate-45 origin-left top-0 left-0"></div>
                            <div class="absolute w-2 h-[1px] bg-[#948A78] transform -rotate-45 origin-left bottom-0 left-0"></div>
                          </div>
                        </div>
                      </div>

                      <div className="flex flex-col ml-auto max-w-[260px] space-y-4">
                        <p>
                          This space is designed for pause. <br /> For
                          conversation.
                          <br />
                          For silence. <br /> For everything in between.
                        </p>

                        <p>
                          One seating is a deep, sectional sofa, perfect for
                          long hours and even longer conversations. Another
                          faces the TV, for easy, familiar comfort. In one
                          corner, a round window offers a cozy reading spot.
                        </p>

                        <p className="hidden sm:block">
                          There’s also a small bar tucked into the space, ideal
                          for an evening drink.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="lg:hidden min-w-[300px] w-[96vw] flex-shrink-0 py-2 pl-4 bg-purple-500/0">
                  <div className="grid grid-cols-1 md:grid-cols-2 h-full">
                    <img
                      src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/fe12801d-ae41-4ad6-ec2d-26935c679a00/public" // Tao_homepage_banner.webp
                      alt="Img"
                      className="h-[35vh] md:h-[50vh] w-[90%] md:w-full object-cover object-center md:self-top"
                    />

                    <div className="ml-5 md:self-end">
                      <div className="flex justify-end gap-5 my-6">
                        <p className="uppercase">bedroom 02</p>
                        <div class="flex items-center">
                          <div class="h-[1px] w-28 bg-[#948A78]"></div>

                          <div class="relative w-3 h-3 -ml-1">
                            <div class="absolute w-2 h-[1px] bg-[#948A78] transform rotate-45 origin-left top-0 left-0"></div>
                            <div class="absolute w-2 h-[1px] bg-[#948A78] transform -rotate-45 origin-left bottom-0 left-0"></div>
                          </div>
                        </div>
                      </div>

                      <div className="flex flex-col ml-auto max-w-[260px] space-y-4">
                        <p>
                          This space is designed for pause. <br /> For
                          conversation.
                          <br />
                          For silence. <br /> For everything in between.
                        </p>

                        <p>
                          One seating is a deep, sectional sofa, perfect for
                          long hours and even longer conversations. Another
                          faces the TV, for easy, familiar comfort. In one
                          corner, a round window offers a cozy reading spot.
                        </p>

                        <p className="hidden sm:block">
                          There’s also a small bar tucked into the space, ideal
                          for an evening drink.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* DESKTOP - Horizontal section */}
                <div className="hidden lg:block w-[96vw] flex-shrink-0 bg-red-500/0">
                  <div className="grid grid-cols-2 gap-10 items-start justify-between m-10">
                    <div className="flex gap-2 items-center">
                      <div class="flex items-center rotate-180">
                        <div class="h-[1px] w-20 bg-[#948A78]"></div>

                        <div class="relative w-3 h-3 -ml-1">
                          <div class="absolute w-2 h-[1px] bg-[#948A78] transform rotate-45 origin-left top-0 left-0"></div>
                          <div class="absolute w-2 h-[1px] bg-[#948A78] transform -rotate-45 origin-left bottom-0 left-0"></div>
                        </div>
                      </div>

                      <div>
                        <img
                          src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/fcfaf156-fd7c-485a-1734-e3a3ace3c900/public" // Tao_img1.webp
                          alt="Img"
                          className="h-[50vh] 2xl:h-[60vh] w-full object-cover object-center"
                        />

                        <div className="text-sm 2xl:text-lg space-y-5 mt-10">
                          <p>
                            This space is designed for pause. <br />
                            For conversation. <br />
                            For silence. <br />
                            For everything in between. <br />
                          </p>

                          <p>
                            One seating is a deep, sectional sofa, perfect for
                            long hours and even longer conversations. Another
                            faces the TV, for easy, familiar comfort. In one
                            corner, a round window offers a cozy reading spot.
                          </p>

                          <p>
                            There’s also a small bar tucked into the space,
                            ideal for an evening drink.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="flex flex-col items-center">
                      <div className="grid grid-cols-[125px_auto] 2xl:grid-cols-[165px_auto] gap-2">
                        <div className="text-right">
                          <p className="font-bold text-lg 2xl:text-2xl">
                            The Space at <br /> a Glance
                          </p>
                        </div>

                        <div className="text-sm 2xl:text-lg space-y-5 mt-14 2xl:mt-16 w-96 2xl:w-[500px]">
                          <p>
                            A 5-bedroom home with ensuite baths, vaulted living,
                            sun-washed courtyards, a private pool, and an
                            open-sky jacuzzi — designed for connection and calm.
                          </p>

                          <br />
                          <br />

                          <div className="">
                            <a
                              href="/OurSpaces"
                              className="uppercase underline underline-offset-8 hover:underline-offset-4 transition-all ease-in-out duration-300"
                            >
                              our spaces
                            </a>
                          </div>
                        </div>
                      </div>

                      <div>
                        <div className="flex justify-end gap-5 mt-14 2xl:mt-36">
                          <p className="uppercase text-sm 2xl:text-lg">
                            the living room
                          </p>
                          <div class="flex items-center">
                            <div class="h-[1px] w-28 bg-[#948A78]"></div>

                            <div class="relative w-3 h-3 -ml-1">
                              <div class="absolute w-2 h-[1px] bg-[#948A78] transform rotate-45 origin-left top-0 left-0"></div>
                              <div class="absolute w-2 h-[1px] bg-[#948A78] transform -rotate-45 origin-left bottom-0 left-0"></div>
                            </div>
                          </div>
                        </div>
                        <div className="grid grid-cols-2 gap-5 mt-3 ml-40 2xl:ml-72">
                          <img
                            src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/1161b68c-2cc3-4357-0627-906f1a32ae00/public" // tao_img4.webp
                            alt="Img"
                            className="h-[50vh] w-full object-cover object-center"
                          />

                          <img
                            src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/0cd34eb7-aa12-492a-ed1d-de2c1ede2100/public" // tao_img5.webp
                            alt="Img"
                            className="h-[50vh] w-full object-cover object-center"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="hidden lg:block w-[96vw] flex-shrink-0 bg-green-500/0">
                  <div className="grid grid-cols-2 gap-10 items-start justify-between m-10">
                    <div className="flex gap-2 items-center">
                      <div class="flex items-center rotate-180">
                        <div class="h-[1px] w-20 bg-[#948A78]"></div>

                        <div class="relative w-3 h-3 -ml-1">
                          <div class="absolute w-2 h-[1px] bg-[#948A78] transform rotate-45 origin-left top-0 left-0"></div>
                          <div class="absolute w-2 h-[1px] bg-[#948A78] transform -rotate-45 origin-left bottom-0 left-0"></div>
                        </div>
                      </div>

                      <div>
                        <img
                          src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/ceaeea20-ecae-44e3-69c7-7a2510d71c00/public" // tao_img6.webp
                          alt="Img"
                          className="h-[50vh] 2xl:h-[60vh] w-full object-cover object-center"
                        />

                        <div className="text-sm 2xl:text-lg space-y-5 mt-10">
                          <p>
                            The dining space brings people together, it seats 14
                            with ease and opens straight onto the verandah, so
                            the breeze flows in without asking.
                          </p>

                          <p>
                            The light above the table isn’t grand, but it’s
                            quietly special, made with layered fabric, stitched
                            by a local tailor who understood what we were trying
                            to create.
                          </p>

                          <p>
                            When the wind moves through, the light shifts just a
                            little. It’s a space that feels open, gentle and
                            lived in. Meals here tend to stretch longer than
                            planned and that’s exactly how we like it.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="flex flex-col items-center">
                      <div className="grid grid-cols-[125px_auto] 2xl:grid-cols-[165px_auto] gap-2">
                        <div className="text-right">
                          <p className="font-bold text-lg 2xl:text-2xl">
                            The Space at <br /> a Glance
                          </p>
                        </div>

                        <div className="text-sm 2xl:text-lg space-y-5 mt-14 2xl:mt-16 w-96 2xl:w-[500px]">
                          <p>
                            A 5-bedroom home with ensuite baths, vaulted living,
                            sun-washed courtyards, a private pool, and an
                            open-sky jacuzzi — designed for connection and calm.
                          </p>

                          <br />
                          <br />

                          <div className="">
                            <a
                              href="/OurSpaces"
                              className="uppercase underline underline-offset-8 hover:underline-offset-4 transition-all ease-in-out duration-300"
                            >
                              our spaces
                            </a>
                          </div>
                        </div>
                      </div>

                      <div>
                        <div className="flex justify-end gap-5 mt-14 2xl:mt-36">
                          <p className="uppercase text-sm 2xl:text-lg">
                            the dining room
                          </p>
                          <div class="flex items-center">
                            <div class="h-[1px] w-28 bg-[#948A78]"></div>

                            <div class="relative w-3 h-3 -ml-1">
                              <div class="absolute w-2 h-[1px] bg-[#948A78] transform rotate-45 origin-left top-0 left-0"></div>
                              <div class="absolute w-2 h-[1px] bg-[#948A78] transform -rotate-45 origin-left bottom-0 left-0"></div>
                            </div>
                          </div>
                        </div>
                        <div className="grid grid-cols-2 gap-5 mt-3 ml-40 2xl:ml-72">
                          <img
                            src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/81c74f48-70f8-4172-30e6-0b764fcf1100/public" // tao_img7.webp
                            alt="Img"
                            className="h-[50vh] w-full object-cover object-center"
                          />

                          <img
                            src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/6de079fb-a125-449c-48d4-4b788fcc6a00/public" // tao_img8.webp
                            alt="Img"
                            className="h-[50vh] w-full object-cover object-center"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="hidden lg:block w-[96vw] flex-shrink-0 bg-blue-500/0">
                  <div className="grid grid-cols-2 gap-10 items-start justify-between m-10">
                    <div className="flex gap-2 items-center">
                      <div class="flex items-center rotate-180">
                        <div class="h-[1px] w-20 bg-[#948A78]"></div>

                        <div class="relative w-3 h-3 -ml-1">
                          <div class="absolute w-2 h-[1px] bg-[#948A78] transform rotate-45 origin-left top-0 left-0"></div>
                          <div class="absolute w-2 h-[1px] bg-[#948A78] transform -rotate-45 origin-left bottom-0 left-0"></div>
                        </div>
                      </div>

                      <div>
                        <img
                          src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/ede13113-bdec-4b3c-9d08-4e21ed82b700/public" // tao_img9.webp
                          alt="Img"
                          className="h-[50vh] 2xl:h-[60vh] w-full object-cover object-center"
                        />

                        <div className="text-sm 2xl:text-lg space-y-5 mt-10">
                          <p>
                            In a quiet corner, tea is brewed not for caffeine
                            but for consciousness. The ritual is simple, almost
                            sacred.
                          </p>

                          <p>
                            Sip. Pause. Tap the table softly when the cup is
                            empty, a gesture of thanks. The house honors Taoism,
                            not through symbols, but through rhythm.
                          </p>

                          <p>
                            Be here & now. <br />
                            That’s the only rule. <br />
                            That’s the only truth.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="flex flex-col items-center">
                      <div className="grid grid-cols-[125px_auto] 2xl:grid-cols-[165px_auto] gap-2">
                        <div className="text-right">
                          <p className="font-bold text-lg 2xl:text-2xl">
                            The Space at <br /> a Glance
                          </p>
                        </div>

                        <div className="text-sm 2xl:text-lg space-y-5 mt-14 2xl:mt-16 w-96 2xl:w-[500px]">
                          <p>
                            A 5-bedroom home with ensuite baths, vaulted living,
                            sun-washed courtyards, a private pool, and an
                            open-sky jacuzzi — designed for connection and calm.
                          </p>

                          <br />
                          <br />

                          <div className="">
                            <a
                              href="/OurSpaces"
                              className="uppercase underline underline-offset-8 hover:underline-offset-4 transition-all ease-in-out duration-300"
                            >
                              our spaces
                            </a>
                          </div>
                        </div>
                      </div>

                      <div>
                        <div className="flex justify-end gap-5 mt-14 2xl:mt-36">
                          <p className="uppercase text-sm 2xl:text-lg">
                            bedroom 01
                          </p>
                          <div class="flex items-center">
                            <div class="h-[1px] w-28 bg-[#948A78]"></div>

                            <div class="relative w-3 h-3 -ml-1">
                              <div class="absolute w-2 h-[1px] bg-[#948A78] transform rotate-45 origin-left top-0 left-0"></div>
                              <div class="absolute w-2 h-[1px] bg-[#948A78] transform -rotate-45 origin-left bottom-0 left-0"></div>
                            </div>
                          </div>
                        </div>
                        <div className="grid grid-cols-2 gap-5 mt-3 ml-40 2xl:ml-72">
                          <img
                            src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/edddf9f8-8327-4621-09d2-3985d5991200/public" // tao_img10.webp
                            alt="Img"
                            className="h-[50vh] w-full object-cover object-center"
                          />

                          <img
                            src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/72c33a33-1c06-4e0d-397e-6cc70d5be300/public" // tao_img11.webp
                            alt="Img"
                            className="h-[50vh] w-full object-cover object-center"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* Final vertical section */}

            {/* MOBILE - Last vertical section */}
            <section className="lg:hidden h-[590vh] sm:h-[550vh] bg-black/0">
              <div className="h-[70vh] w-full relative max-w-[100vw] overflow-hidden bg-yellow-100/0">
                <div className="grid grid-cols-2 gap-2 mt-10 ml-auto mr-2 w-[80%]">
                  <img
                    src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/fe12801d-ae41-4ad6-ec2d-26935c679a00/public" // Tao_homepage_banner.webp
                    alt="Img"
                    className="h-[46vh] w-full object-cover object-center"
                  />

                  <img
                    src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/fe12801d-ae41-4ad6-ec2d-26935c679a00/public" // Tao_homepage_banner.webp
                    alt="Img"
                    className="h-[46vh] w-full object-cover object-center"
                  />
                </div>
              </div>

              <div className="h-[100vh] w-full relative max-w-[100vw] overflow-hidden bg-blue-100/0">
                <img
                  src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/fe12801d-ae41-4ad6-ec2d-26935c679a00/public" // Tao_homepage_banner.webp
                  alt="Img"
                  className="h-full w-full object-cover object-center"
                />

                <div className="absolute bottom-10 left-1/2 -translate-x-1/2 w-full">
                  <p className="uppercase text-center">
                    in silence, everything speaks
                  </p>
                </div>
              </div>

              <div className="h-[100vh] w-full relative max-w-[100vw] overflow-hidden bg-red-100/0">
                <div className="absolute right-2 top-20">
                  <div>
                    <p className="uppercase font-bold">our services</p>

                    <p className="mt-8 max-w-[300px] bg-red-900/0">
                      Curated experiences, thoughtfully delivered At House of
                      Tāo, our in-house concierge service is here to enhance
                      your stay with curated experiences, local insights, and
                      seamless planning — so you can focus on unwinding.
                    </p>
                  </div>
                </div>

                <div className="absolute top-80">
                  <img
                    src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/fe12801d-ae41-4ad6-ec2d-26935c679a00/public" // Tao_homepage_banner.webp
                    alt="Img"
                    className="h-[50vh] w-[80%] sm:w-full object-cover object-center"
                  />
                </div>
              </div>

              <div className="h-[320vh] sm:h-[280vh] w-full relative max-w-[100vw] overflow-hidden bg-green-100/0">
                <div className="grid grid-cols-[125px_auto] sm:gap-2 mt-20 justify-end mr-5">
                  <div className="text-right">
                    <p className="font-bold text-lg ml-2 sm:ml-0">
                      What&nbsp;We&nbsp;Offer
                    </p>
                  </div>

                  <div className="text-sm space-y-5 mt-14 lg:mt-10 w-44 sm:w-80">
                    <p>Our concierge can assist you with:</p>

                    <p>
                      • Restaurant reservations at some of Goa’s best culinary
                      spots{" "}
                    </p>

                    <p>• Private transfers & guided itineraries </p>

                    <p>
                      • Spa appointments, wellness sessions & yoga instructors{" "}
                    </p>

                    <p>• Decor for intimate celebrations </p>

                    <p>• On-call chef experiences & wine/gin tastings </p>

                    <p>
                      • Yacht charters, beach picnics & cultural explorations
                    </p>

                    <br />
                    <br />

                    <p>
                      All in-villa services (spa, setup, décor, etc.) must be
                      booked through our concierge to ensure quality, safety,
                      and consistency of service.
                    </p>

                    <br />
                    <br />

                    <p>
                      We’re here to ensure your stay is not only peaceful, but
                      seamless — curated with care, hosted with intention. For
                      any assistance, please reach out to your Villa Manager or
                      Concierge Team directly during your stay.
                    </p>

                    <br />
                    <br />

                    <div className="">
                      <a
                        href="/"
                        className="uppercase underline underline-offset-8 hover:underline-offset-4 transition-all ease-in-out duration-300"
                      >
                        explore&nbsp;our&nbsp;services
                      </a>
                    </div>
                  </div>
                </div>

                <div className="ml-5 mt-20">
                  <img
                    src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/fe12801d-ae41-4ad6-ec2d-26935c679a00/public" // Tao_homepage_banner.webp
                    alt="Img"
                    className="h-[80vh] w-[80%] sm:w-[70%] object-cover object-center"
                  />

                  <div className="flex flex-col ml-auto mr-5 text-sm space-y-5 mt-14 w-60 sm:w-80">
                    <p>
                      Whether you’re planning your next getaway, looking for a
                      special celebration venue, or simply curious to know more
                      — we’d love to hear from you.
                    </p>

                    <br />
                    <br />

                    <div className="">
                      <a
                        href="/"
                        className="uppercase underline underline-offset-8 hover:underline-offset-4 transition-all ease-in-out duration-300"
                      >
                        BOOK YOUR STAY
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* DESKTOP - Last vertical section */}
            <section className="hidden lg:block h-[315vh] bg-black/0">
              <div className="h-[100vh] w-full relative max-w-[100vw] overflow-hidden bg-blue-100/0">
                <img
                  src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/674a0f9e-4709-4fd8-9d3e-827e3707a500/public" // tao_img12.webp
                  alt="Img"
                  className="h-full w-full object-cover object-center"
                />

                <div className="absolute bottom-10 left-1/2 -translate-x-1/2 w-full">
                  <p className="uppercase text-center">
                    in silence, everything speaks
                  </p>
                </div>
              </div>

              <div className="h-[100vh] w-full relative max-w-[100vw] overflow-hidden bg-orange-400/0">
                <div className="grid grid-cols-2 xl:gap-20 justify-between items-end mx-10 mt-14">
                  <div className="flex flex-col gap-10 2xl:gap-20">
                    <div className="self-center text-sm 2xl:text-lg">
                      <p className="uppercase font-bold">our services</p>

                      <p className="mt-8 max-w-[400px] 2xl:max-w-[600px] bg-red-900/0">
                        Curated experiences, thoughtfully delivered At House of
                        Tāo, our in-house concierge service is here to enhance
                        your stay with curated experiences, local insights, and
                        seamless planning — so you can focus on unwinding.
                      </p>
                    </div>

                    <img
                      src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/7d785301-7c6b-4a1d-87be-dd345efddd00/public" // tao_img13.webp
                      alt="Img"
                      className="h-[60vh] w-[90%] ml-[10%] object-cover object-center"
                    />
                  </div>

                  <div>
                    <div className="grid grid-cols-[125px_auto] 2xl:grid-cols-[180px_auto] gap-2 mr-5">
                      <div className="text-right">
                        <p className="font-bold text-lg 2xl:text-2xl">
                          What&nbsp;We&nbsp;Offer
                        </p>
                      </div>

                      <div className="text-sm 2xl:text-lg space-y-2 mt-14 lg:mt-10 max-w-[500px] 2xl:max-w-[600px]">
                        <p>Our concierge can assist you with:</p>

                        <p>
                          • Restaurant reservations at some of Goa’s best
                          culinary spots{" "}
                        </p>

                        <p>• Private transfers & guided itineraries </p>

                        <p>
                          • Spa appointments, wellness sessions & yoga
                          instructors{" "}
                        </p>

                        <p>• Decor for intimate celebrations </p>

                        <p>• On-call chef experiences & wine/gin tastings </p>

                        <p>
                          • Yacht charters, beach picnics & cultural
                          explorations
                        </p>

                        <br />
                        <br />

                        <p>
                          All in-villa services (spa, setup, décor, etc.) must
                          be booked through our concierge to ensure quality,
                          safety, and consistency of service.
                        </p>

                        <br />
                        <br />

                        <p>
                          We’re here to ensure your stay is not only peaceful,
                          but seamless — curated with care, hosted with
                          intention. For any assistance, please reach out to
                          your Villa Manager or Concierge Team directly during
                          your stay.
                        </p>

                        <br />
                        <br />

                        <div className="">
                          <a
                            href="/"
                            className="uppercase underline underline-offset-8 hover:underline-offset-4 transition-all ease-in-out duration-300"
                          >
                            explore&nbsp;our&nbsp;services
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="h-[100vh] w-full relative max-w-[100vw] overflow-hidden bg-purple-400/0">
                <div className="grid grid-cols-[400px_auto] gap-5 justify-between items-end ml-10 mt-10">
                  <div className="text-sm 2xl:text-lg">
                    <p className="uppercase font-bold">
                      Location & Surroundings
                    </p>

                    <div className="space-y-5 mt-10 mb-24">
                      <p>
                        Curated experiences, thoughtfully delivered At House of
                        Tāo, our in-house concierge service is here to enhance
                        your stay with curated experiences, local insights, and
                        seamless planning — so you can focus on unwinding.
                      </p>

                      <p>
                        It’s not where the parties are, but they’re not far
                        either. Beaches like Anjuna and Vagator, and the cafés
                        of Assagao, are just a short drive away.
                      </p>

                      <p>
                        That’s what makes this place special: it gives you room
                        to retreat, without losing touch with everything else.
                      </p>
                    </div>
                  </div>

                  <img
                    src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/fe12801d-ae41-4ad6-ec2d-26935c679a00/public" // Tao_homepage_banner.webp
                    alt="Img"
                    className="h-[100vh] w-full object-cover object-center"
                  />
                </div>
              </div>
            </section>
          </div>

          <Footer />
        </div>
      </div>
    </>
  );
};
export default Home;

// ==============================================  WORKING IN CHROME  =====================================================

// import React, { useRef, useEffect } from "react";
// import gsap from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";

// gsap.registerPlugin(ScrollTrigger);

// const Home = () => {
//   const horizontalSection = useRef(null);

//   useEffect(() => {
//     const panels = gsap.utils.toArray(".panel");
//     const totalPanels = panels.length;

//     gsap.to(panels, {
//       xPercent: -100 * (totalPanels - 1), // move all panels left
//       ease: "none",
//       scrollTrigger: {
//         trigger: horizontalSection.current,
//         pin: true,
//         scrub: 1,
//         snap: 1 / (totalPanels - 1),
//         end: () => "+=" + horizontalSection.current.offsetWidth,
//       },
//     });

//     // refresh ScrollTrigger when layout changes
//     ScrollTrigger.refresh();
//   }, []);

//   return (
//     <div className="w-full">
//       {/* First vertical section */}
//       <section className="h-screen flex items-center justify-center bg-teal-500 text-white text-4xl font-bold">
//         First Vertical Section
//       </section>

//       {/* Horizontal scroll section */}
//       <section
//         ref={horizontalSection}
//         className="relative h-screen overflow-hidden bg-gray-900 text-white"
//       >
//         <div className="flex w-[400vw] h-full">
//           <div className="panel w-screen flex items-center justify-center bg-red-500 text-3xl font-bold">
//             Panel 1
//           </div>
//           <div className="panel w-screen flex items-center justify-center bg-green-500 text-3xl font-bold">
//             Panel 2
//           </div>
//           <div className="panel w-screen flex items-center justify-center bg-blue-500 text-3xl font-bold">
//             Panel 3
//           </div>
//           <div className="panel w-screen flex items-center justify-center bg-purple-500 text-3xl font-bold">
//             Panel 4
//           </div>
//         </div>
//       </section>

//       {/* Final vertical section */}
//       <section className="h-screen flex items-center justify-center bg-black text-white text-4xl font-bold">
//         Final Vertical Section
//       </section>
//     </div>
//   );
// };

// export default Home;
